var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteImplant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM4 7V9H12V7H4Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.00002C17 8.59074 16.9431 9.16818 16.8344 9.72714C16.8623 9.72756 16.8906 9.72778 16.9194 9.72778C18.0633 9.72779 19.1145 9.44929 19.6289 9.25925L19.6918 9.23606C20.1533 9.06626 20.191 9.08576 20.2668 9.12494L20.2844 9.1339C20.4442 9.21227 20.5847 9.31009 20.6977 9.45802C20.8074 9.60143 20.9366 9.85097 20.9828 10.3041C21.0581 11.0425 20.9067 12.2663 20.1479 14.2412H14.4844C13.8452 14.9052 13.1049 15.4713 12.2883 15.9146C12.4402 16.2691 12.5928 16.5979 12.7382 16.891L13.2213 20.683C13.2618 21.0007 13.4553 21.2799 13.7413 21.4333L16.4345 22.8782C16.7368 23.0404 17.1022 23.0406 17.4047 22.8788L20.1959 21.3855C20.4825 21.2322 20.6764 20.9527 20.717 20.6346L21.1957 16.8766C22.6688 13.7111 23.1236 11.5834 22.9725 10.1012C22.8934 9.32511 22.6468 8.71418 22.2865 8.24297C21.9298 7.77629 21.5065 7.50533 21.1651 7.33785C20.2617 6.89471 19.5224 7.16684 19.0161 7.35319L18.9499 7.37755C18.4952 7.54523 17.7542 7.71588 16.9959 7.7268C16.9986 7.81754 17 7.90862 17 8.00002ZM14.6785 16.2955L14.651 16.2416H19.2845L19.2515 16.3116L19.133 17.2418H14.7991L14.6785 16.2955ZM15.0539 19.2423L15.1336 19.8673L16.9194 20.868L18.7924 19.915L18.8782 19.2423H15.0539Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImplant);
export default __webpack_public_path__ + "static/media/delete-implant.096663ac.svg";
export { ForwardRef as ReactComponent };